import { getWTaxRates } from "API";
import getDepartments from "API/functions/getDepartments";
import numeral from "numeral";
import moment from "moment";

export default async function (crfList) {
  const wTaxRates = await getWTaxRates();
  const departments = await getDepartments();
  const csvData = [];
  for (const obj of crfList) {
    const objDate = obj.creationDate.toString().split(" ");
    const crfDate = `${objDate[1]} ${objDate[2]},${objDate[3]} ${objDate[4]}`;
    obj.projectClasses.forEach((lineItem, index) => {
      const wTax = wTaxRates.response.find(
        (data) => data.wTaxCode === lineItem.wTaxCode
      );

      const department = departments.response.find(
        (data) => data.centerName === lineItem.classDepartment
      );

      // csvData.push({
      //   'CRF#': obj.crfNo,
      //   'CRF Date': crfDate,
      //   'PO#': obj.poNumber ? obj.poNumber : 'N/A',
      //   'Item#': glAccount.itemCode,
      //   Particulars: obj.particulars,
      //   Department: department?.centerCode
      //     ? department?.centerCode
      //     : obj.department.centerCode,
      //   Project: obj.project.projectCode,
      //   'Project Name': obj.project.projectName,
      //   'Sub Project': obj.subProject,
      //   'Vendor Code': obj.vendor.bpCode,
      //   'Vendor Name': obj.vendor.bpName,
      //   'Releasing Center': obj.releasingCenter,
      //   'G/L Account': glAccount.glAccount.accountCode,
      //   'G/L Account Name': glAccount.glAccount.accountName,
      //   'Project Class': glAccount.glAccount.centerCode,
      //   'Project Class Name': glAccount.glAccount.centerName,
      //   '1st Description': glAccount.description1,
      //   '2nd Description': glAccount.description2,
      //   'S Gross Price': glAccount.grossPricePerItem.toFixed(2),
      //   'Tax Code':
      //     glAccount.vatType.split(' ')[1] === 'IVAT-X1'
      //       ? 'X1'
      //       : glAccount.vatType.split(' ')[1],
      //   'WTax Liable': glAccount.wTaxCode !== 'X1' ? 'Yes' : 'No',
      //   'WTax Code': glAccount.wTaxCode === 'X1' ? 'X' : glAccount.wTaxCode,
      //   'WTax Rate': wTax?.rate ? wTax?.rate : '',
      //   'Unit Price': glAccount.apv.unitPrice.toFixed(2),
      //   'S QTY': glAccount.quantity.toFixed(2),
      //   'Gross Total': glAccount.apv.subTotalGrossPrice.toFixed(2),
      //   'Total (LC)': glAccount.apv.subTotalNetPrice.toFixed(2),
      //   'S UOM': 'LOT',
      //   'APV #': obj?.apvNo,
      //   'CV #': obj?.cvNo
      // })
      csvData.push({
        "CRF#": obj.crfNo,
        "Date Created": obj.creationDate
          ? moment(obj.creationDate).format("MMM DD, YYYY")
          : "-",
        "Expected Date Completion": obj.expectedCompletionDate
          ? moment(obj.expectedCompletionDate).format("MMM DD, YYYY HH:MM")
          : "-",
        "Due Date": obj.dueDate
          ? moment(obj.dueDate).format("MMM DD, YYYY")
          : "-",
        "Project Name": obj.project.projectName,
        "Vendor Name": obj.vendor.bpName,
        Department: department?.centerCode
          ? department?.centerCode
          : obj.department.centerCode,
        "Budget Line Item": lineItem.glAccount.budgetLineItem,
        "Account Code/Name": `${lineItem.glAccount.accountCode} /${lineItem.glAccount.accountName}`,
        "Requested Gross Price": lineItem.apv?.subTotalGrossPrice
          ? numeral(lineItem.apv.subTotalGrossPrice).format("0,0.00")
          : "-",
        "VAT Amount": numeral(lineItem.apv.vat).format("0,0.00"),
        "Withholding Tax": numeral(lineItem.apv.wTax).format("0,0.00"),
        "Total Net Price": numeral(obj.totalNetPrice).format("0,0.00"),
        Status: obj.status ? obj.status : "-",
        "APV #": obj?.apvNo,
        "CV #": obj?.cvNo,
        Requestor: `${obj.requestor.lastName}, ${obj.requestor.firstName}`,
        Particulars: obj.particulars,
      });
      // if (obj.requestType !== 'Cash Advance' || obj.requestType !== 'Liquidation') {
      //   newData['Sub Project'] = obj.subProject
      //   newData.Department = department?.centerCode
      //     ? department?.centerCode
      //     : obj.department.centerCode
      // }
      // csvData.push(newData)
    });
  }
  return csvData;
}

// export const accountingManagerDownload = async crfList => {
//   const wTaxRates = await getWTaxRates()
//   const departments = await getDepartments()
//   const csvData = []
//   for (const obj of crfList) {
//     const objDate = obj.creationDate.toString().split(' ')
//     const expectedCompletion = obj?.expectedCompletionDate?.toString()
//     const crfDate = `${objDate[1]} ${objDate[2]},${objDate[3]} ${objDate[4]}`
//     obj.projectClasses.forEach((glAccount, index) => {
//       const wTax = wTaxRates.response.find(
//         data => data.wTaxCode === glAccount.wTaxCode
//       )

//       const department = departments.response.find(
//         data => data.centerName === glAccount.classDepartment
//       )

//       csvData.push({
//         'CRF#': obj.crfNo,
//         'Date Created': crfDate,
//         'Expected Completion Date': dateWithComma(expectedCompletion),
//         'Due Date': obj.dueDate ? formatDate(obj.dueDate) : '',
//         'Project Name': obj.project.projectName,
//         'Vendor Name': obj.vendor.bpName,
//         Department: department?.centerCode
//           ? department?.centerCode
//           : obj?.department.centerCode,
//         Status: obj.status
//       })
//     })
//   }
//   return csvData
// }

export const accountingManagerDownload = async (crfList) => {
  // const wTaxRates = await getWTaxRates()
  // const departments = await getDepartments()
  var formatter = new Intl.NumberFormat("en-US");

  const csvData = [];
  for (const obj of crfList) {
    const objDate = obj.creationDate.toString().split(" ");
    const expectedCompletion = obj?.expectedCompletionDate?.toString();
    const crfDate = `${objDate[1]} ${objDate[2]},${objDate[3]} ${objDate[4]}`;
    csvData.push({
      "CRF#": obj.crfNo,
      "Date Created": crfDate,
      "Expected Completion Date": dateWithComma(expectedCompletion),
      "Due Date": obj.dueDate ? formatDate(obj.dueDate) : "",
      "Project Name": obj.project.projectName,
      "Vendor Name": obj.vendor.bpName,
      Department: obj?.department.centerCode,
      "Amount Requested": obj?.totalNetPrice,
      // 'Amount Requested': formatter.format(obj?.totalNetPrice),
      Status: obj.status,
    });
  }
  return csvData;
};

export const dateWithComma = (date) => {
  if (typeof date === "undefined" || date === "") {
    return "";
  }
  const newDate = date.split(" ");
  const month = newDate[1];
  const day = newDate[2];
  const year = newDate[3];
  return `${month} ${day}, ${year}`;
};

export const formatDate = (date) => {
  if (typeof date === "undefined" || date === "") {
    return "";
  }
  let dateArray = "";
  let month = "";
  let day = "";
  let year = "";

  if (date.length === 10) {
    dateArray = date.split("/");
    month = dateArray[0];
    day = dateArray[1];
    year = dateArray[2];
  } else {
    dateArray = date.split("-");
    month = dateArray[1];
    day = dateArray[2].substring(0, 2);
    year = dateArray[0];
  }
  switch (dateArray[1]) {
    case "02":
      month = "Feb";
      break;
    case "03":
      month = "Mar";
      break;
    case "04":
      month = "Apr";
      break;
    case "05":
      month = "May";
      break;
    case "06":
      month = "Jun";
      break;
    case "07":
      month = "Jul";
      break;
    case "08":
      month = "Aug";
      break;
    case "09":
      month = "Sep";
      break;
    case "10":
      month = "Oct";
      break;
    case "11":
      month = "Nov";
      break;
    case "12":
      month = "Dec";
      break;
    default:
      month = "Jan";
  }
  return `${month} ${day}, ${year}`;
};
